import { createContext, useContext } from 'react';
import type Account from '../routes/account/store/Account';
import type { HasRoleOptions } from '../routes/login/store/AuthSession';
import type RootStore from './RootStore';

export const StoreContext = createContext({} as any);

export function useStore(): RootStore {
  return useContext(StoreContext);
}

export function useAccount<TThrow extends boolean = true>({
  throwIfEmpty = true as TThrow,
}: { throwIfEmpty?: TThrow } = {}): TThrow extends true
  ? Account
  : Account | undefined {
  const { accountStore } = useStore();

  if (!accountStore.account && throwIfEmpty) {
    throw new Error(
      'Account store is empty. Please make sure you are logged in.',
    );
  }

  return accountStore.account as Account;
}

export function useIsAdmin(options?: HasRoleOptions) {
  const { authStore } = useStore();
  return authStore.userHasRole('ADMIN', options);
}
